"use client";

// Import react
import {useEffect} from "react";

// Next Imports
import {useSession} from "next-auth/react";

// Import third party
import Pusher from "pusher-js";

// Store Imports
import {useDispatch} from "react-redux";

// Hooks imports
import {toast} from "react-toastify";

// Slice Imports
import {fetch} from "@/redux-store/slices/userNotifications";

const option = {
  appId: process.env.NEXT_PUBLIC_PUSHER_APPID,
  secret: process.env.NEXT_PUBLIC_PUSHER_SECRET,
  cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER as string,
  useTLS: process.env.NEXT_PUBLIC_PUSHER_TLS,
};

const pusher = new Pusher(process.env.NEXT_PUBLIC_PUSHER_KEY as string, option);

Pusher.log = function (msg) {
  console.log(msg);
};

const WebSocketClient: any = (params: any) => {
  const {data: session} = useSession();
  const {dictionary} = params;

  // Hooks
  const dispatch = useDispatch();

  useEffect(() => {
    if (session && session.user.sessionId) {
      const channel: any = pusher.subscribe("user-" + session?.user?.sessionId);

      console.log("Pusher sessionId: ", session?.user?.sessionId);

      channel.bind("send-push", (data: any) => {
        if (data.data) {
          dispatch(fetch(undefined) as any);

          // Push alerts notify app
          if (data.app) {
            if (
              // Show as error notification type
              data.data.type === "teams.request.canceled" ||
              data.data.type === "teams.user.removed" ||
              data.data.type === "teams.request.declined" ||
              data.data.type === "reviews.canceled" ||
              data.data.type === "feedback.canceled"
            ) {
              toast.error(dictionary["notificationsTitles"][data.data.type]);
            } else {
              toast.success(dictionary["notificationsTitles"][data.data.type]);
            }
          }

          // Browser windows alerts
          if (data.browser) {
            const dataParsed = JSON.parse(data.data.data);

            const typesBodyList: any = {
              "teams.request.canceled": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace(
                "{teamname}",
                dataParsed.teamname
              ),
              "teams.request.join": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace("{teamname}", dataParsed.teamname),
              "teams.user.added": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace("{teamname}", dataParsed.teamname),
              "teams.user.removed": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace("{teamname}", dataParsed.teamname),
              "teams.request.accepted": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace(
                "{teamname}",
                dataParsed.teamname
              ),
              "teams.request.declined": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace(
                "{teamname}",
                dataParsed.teamname
              ),
              "feedback.completed": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace("{feedback}", dataParsed.name),
              "feedback.added": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace("{feedback}", dataParsed.name),
              "feedback.canceled": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace("{feedback}", dataParsed.name),
              "reviews.canceled": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace("{review}", dataParsed.name),
              "reviews.added": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace("{review}", dataParsed.name),
              "reviews.assessor.added": dictionary["notificationsTitles"][data.data.type + ".description"]?.replace("{review}", dataParsed.name),

              // TODO Add more types from the schuduler reminders
            };

            const options: any = {
              body: typesBodyList[data.data.type],
              icon: process.env.NEXT_PUBLIC_LOGO_URL || "/images/logos/edupop.png",
              dir: "ltr",
            };

            const notification = new Notification(dictionary["notificationsTitles"][data.data.type], options);

            notification.onclick = function (event) {
              event.preventDefault(); // prevent the browser from focusing the Notification's tab

              if (data.notificationId) {
                window.open(process.env.NEXT_PUBLIC_APP_URL + "/notifications?id=" + data.notificationId, "_blank");
              }
            };
          }
        }
      });

      return () => {
        channel.unbind();
      };
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);
};

export default WebSocketClient;
